export function getOrganization(data) {
    let { getOrganizationRequest, getOrganizationError, getOrganizationResult } = this.props

    this.doAction(
        this.WEB_REQUEST_URL + 'get_organization',
        this.createBundle('get_organization', { id: data }, this.GET, getOrganizationRequest, getOrganizationResult, getOrganizationError)
    )
}
